$shm_service_task_menu $shm_remove_menu
	pinned? false
	archived? false
	pin_enabled false
	archive_enabled false
	remove_confirm_title \Удалить задачу?
	hint \Действия с задачей
	align \bottom_right
	Pin $mol_button_minor
		title <= pin_title \
		click? <=> pin_toggle? null
	Archive $mol_button_minor
		title <= archive_title \
		click? <=> archive_toggle? null
